// Vendored from lib/helper/dynamic-injection/offer-ladder.ts: DDS imports nothing outside
// directv-design-system/. The phrase is legal copy, so keep it byte-identical to the source.

/** 1 → "1st", 2 → "2nd", 3 → "3rd", 11 → "11th" … */
const getOrdinal = (n: number): string => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

/**
 * Duration phrase for a segment spanning `startMonth..endMonth`.
 *   getMultiOfferDuration(null, 24) → "24 mos" ; (null, 1) → "1st mo"
 *   getMultiOfferDuration(1, 1)     → "1st mo"  ; (2, 24)   → "2-24"
 */
export const getMultiOfferDuration = (startMonth: number | null, endMonth: number): string => {
  if (startMonth === null && endMonth > 1) {
    return `${endMonth} mos`;
  }
  if (startMonth === null && endMonth === 1) {
    return "1st mo";
  } else if (startMonth === endMonth) {
    return `${getOrdinal(startMonth)} mo`;
  } else if (endMonth - startMonth === 1) {
    return `${startMonth}&${endMonth}`;
  }
  return `${startMonth}-${endMonth}`;
};
